<script>
import api from '@/api'
import { alertSuccess, alertConfirm } from '@/helpers/swal'

export default {
  data() {
    return {
      loading: true,
      pagetitle: 'Roles',
      roles: [],
    }
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    getRoles() {
      api
        .get(`/admin/roles/${this.authUser.gid}/list.json`)
        .then((response) => {
          this.roles = response.data?.result || []
        })
        .finally(() => {
          this.loading = false
        })
    },

    deleteRole(roleId) {
      alertConfirm('You want to delete this role').then((result) => {
        if (result.value) {
          api.post(`/admin/roles/remove/${roleId}.json`).then(() => {
            alertSuccess('Role deleted successfully')
            this.getRoles()
          })
        }
      })
    },

    showActionColumn() {
      return this.authUserHasPermission('system_admin_roles_edit') || this.authUserHasPermission('system_admin_roles_delete')
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-4 col-md-6">
              <!-- <div class="input-group">
                <input type="search" class="form-control" placeholder="Search here" />
                <span class="input-group-text cursor-pointer">
                  <i class="bx bx-search"></i>
                </span>
              </div> -->
            </div>
            <div class="col-md-6 col-lg">
              <div class="d-flex justify-content-end">
                <router-link v-if="authUserHasPermission('system_admin_roles_add')" to="/roles/create" class="btn btn-primary d-flex align-items-center gap-1">
                  <i class="bx bx-plus"></i>
                  Add New
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Name</th>
                      <th v-if="showActionColumn()">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in showActionColumn() ? 2 : 1" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="roles.length">
                      <tr v-for="(role, roleIndex) in roles" :key="roleIndex">
                        <td>{{ role.roleName }}</td>
                        <td v-if="showActionColumn()">
                          <div class="d-flex gap-2">
                            <router-link
                              v-if="authUserHasPermission('system_admin_roles_edit')"
                              :to="'/roles/' + role.id + '/edit'"
                              class="btn btn-primary bg-gradient btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Edit"
                            >
                              <eva-icon name="edit" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </router-link>
                            <button
                              v-if="authUserHasPermission('system_admin_roles_delete')"
                              type="button"
                              class="btn btn-danger bg-gradient btn-sm"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Delete"
                              @click="deleteRole(role.id)"
                            >
                              <eva-icon name="trash-2" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="2" class="text-center">No roles found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
